const initialState = {
	currentCollectionId: null,
	filtersFromSavedSearch: null,
	filtersStoredForRouteChange: null,
	queryDescription: "",
	queryId: "",
	queryName: "",
	queryString: "",
	agentsSearchesAvailable: [],
};

const agentsTabReducer = (state = initialState, action) => {
	switch (action.type) {
		default:
			return state;
	}
};

export default agentsTabReducer;
